import React, { useEffect } from 'react'
import PageContent from '../../components/PageContent/PageContent'
import { useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { useSearchBusinessProfilesQuery } from '../../api/dataApi';
import './style.scss'
import CustomTitle from '../../components/UI/title/CustomTitle';
import { useDispatch, useSelector } from 'react-redux';
import { setButtonClick, setIconButton, setIsShowButton, setTextButton } from '../../store/buttonSlice';
import { setIsShowButtonNot } from '../../store/buttonNotSlice';
import AiSetupContent from './AiSetupContent';
import useMixpanel from '../../hooks/useMixpanel';

export default function AiSetup() {
    const history = useHistory();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);


    const dispatch = useDispatch();
    const buttonClicked = useSelector((state) => state.button.buttonClicked);
    const nextPage = useSelector((state) => state.appRoute.nextPage);
    useEffect(() => {
        dispatch(setIsShowButton(true));
        dispatch(setTextButton('Continue'));
        dispatch(setIconButton(''));
        dispatch(setIsShowButtonNot(false));
    }, []);
    const {trackP1Event} = useMixpanel();
    useEffect(() => {
        if (buttonClicked) {
            dispatch(setButtonClick(false));
            trackP1Event('onboarding_features', {})
            history.push({
                pathname: nextPage,
                search: `?${queryParams.toString()}`
            });
        }
    }, [buttonClicked, dispatch]);


    return (
        <div className="page ai-setup">
            <div className="page-top">
                <CustomTitle style={{ marginBottom: "24rem" }} title="Check out the features<br> included in your AI setup" />

                <AiSetupContent />
            </div>
        </div>
    )
}
